import Avatar from 'components/Avatar';
import Toast from 'components/Toast';
import { FadeOut } from 'components/Transitions';
import { ACTIONS } from 'constants/hook';
import { useConversation } from 'hooks/conversation';
import { useCustomer } from 'hooks/customer';
import { useView } from 'hooks/view';
import { useEffect, useState } from 'react';
import { htmlId } from 'utils/html';
import { DISPLAY_DURATION } from './constants';
import { AvatarContainer, ChatNow } from './AdvocateAvailableToast.styles';

const AdvocateAvailableToast = (props: any) => {
  const { viewState, dispatchViewAction } = useView();

  const { conversationState } = useConversation();
  const {
    participants: { advocates },
    twilio,
  } = conversationState;

  const {
    customerState: {
      userInfo: { firstName },
    },
  } = useCustomer();

  const lastAssignedAdvocates = advocates.reverse();
  const orderedParticipants = [...lastAssignedAdvocates];

  const displayParticipant = orderedParticipants[0];

  const [hasNewMessages, setHasNewMessages] = useState(false);

  const isVisible = () => !viewState.isPanelOpen && displayParticipant && hasNewMessages;

  // Used to determine if Toast should be shown at all
  const [visible, setVisible] = useState(isVisible);

  // Used to trigger Fade out transition
  const [out, setOut] = useState(false);

  const startTimeout = () => {
    const timeout = setTimeout(() => {
      setOut(true);
    }, DISPLAY_DURATION);

    return timeout;
  };

  // Watch for visibility changes
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (visible) {
      timeout = startTimeout();
      setOut(false);
    } else {
      setOut(true);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [visible]);

  useEffect(() => {
    twilio?.conversation
      .getUnreadMessagesCount()
      .then((result) => setHasNewMessages((result ?? 0) > 0));
  }, [conversationState]);

  // Watch for message alerts
  useEffect(() => {
    setVisible(isVisible());
    setOut(!isVisible());
  }, [hasNewMessages]);

  if (!visible) return null;

  const openChat = () => {
    dispatchViewAction({
      type: ACTIONS.CHANGE,
      payload: {
        ...viewState,
        isPanelOpen: true,
      },
    });
    setVisible(false);
  };

  return (
    <FadeOut out={out}>
      <Toast
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setVisible(false);
        }}
        onClick={openChat}
      >
        <AvatarContainer id={htmlId('toast-advocate-available-avatar-container')}>
          <Avatar participantName={displayParticipant?.name ?? ''} showPresence size='3rem' />
        </AvatarContainer>
        <Toast.Text.Container>
          <Toast.Text.Title>{displayParticipant?.name}</Toast.Text.Title>
          <Toast.Text.Info>
            Hey{firstName ? ' ' : ''}
            {firstName}, I&apos;m ready to chat with you now!{' '}
            <ChatNow onClick={openChat}>Chat now!</ChatNow>
          </Toast.Text.Info>
        </Toast.Text.Container>
      </Toast>
    </FadeOut>
  );
};

export default AdvocateAvailableToast;
